<template>
  <div class="award">
    <div class="title"><img src="@/assets/reservation/tiele02.png" alt="" /></div>
    <div class="content">

          <p>ยอดผู้ลงทะเบียนขณะนี้ </p>
      <div class="text">

        <div class="rightArrow"></div>
       <div class="totals">
       <span>{{totals}}</span>
       </div>
       <div class="leftArrow"></div>
      </div>
      <!-- <img
        src="@/assets/reservation/bg_quantity.png"
        alt=""
      /> -->
    </div>
    <div class="group">
      <ul class="swiper-wrapper">
        <li class="swiper-slide" v-for="(item, index) in group" :key="index">
          <img :src="
          gear>=item ?
          require('@/assets/reservation/reward_reach_0'+(index+1)+'.png'):
          require('@/assets/reservation/reward_default_0'+(index+1)+'.png')" />
        </li>
      </ul>
    </div>
       <div class="img-splitline" @click="slideTo4">
        <img src="@/assets/reservation/img_splitline.png" alt="">
      </div>
  </div>
</template>
<script>
import { getGear } from "@/api/reservation";
import filters from "@/utils/filters";
import Swiper from "swiper/swiper-bundle.min.js";
import "swiper/swiper-bundle.min.css";
export default {
  data() {
    return {
      clientWidth: document.body.clientWidth,
      totals: '100,000',
      group: ['5000', '10000', '15000', '50000'],
      gear: ''
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.currentGear();
     if(this.clientWidth<=768){
         this.initSwiper();
     }
  },
  methods: {
    handleResize() {
      this.clientWidth = document.body.clientWidth;
      if(this.clientWidth<=768){
         this.initSwiper();
      }
    },
    cafe() {
      window.open("https://cafe.naver.com/dragonwrath/11", "_blank").location;
    },
    slideTo4() {
      this.$emit("fullPageSlide", 3);
    },
    initSwiper(){
       let that = this;
      new Swiper(".group", {
        watchSlidesProgress: true,
        slidesPerView: that.clientWidth > 900 ? 3 : 1.2,
        centeredSlides: true,
        loop: false,
        autoplay: false,
        autoHeight: true
      });
    },
    async currentGear(){
       let result = await getGear({});
       console.log(result)
       if(result.status === 200){
         this.gear = result.data.gear;
         this.totals = filters.priceFormat(this.gear);
       }
    }
  },
};
</script>
<style lang="scss" scoped>
.award {
  width: 100%;
  height: 100vh;
  background-image: url("~@/assets/reservation/bg_02.jpg");
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  grid-gap: 2.5%;
    overflow: hidden;
  @media screen and (max-width: 900px) {
    box-sizing: border-box;
    padding: 0 5%;
    grid-gap: 3vh;
  }
  .title {
    width: 47.7%;
    img{
      width: 100%;
    height:auto;
    }
    @media screen and (max-width: 900px) {
      width: 100%;
      // img {
      //   width: 50%;
      // }
    }
  }
  .content {
    position: relative;
    width: 50.9%;
    margin: 0 auto;

    background: url('~@/assets/reservation/bg_quantity.png') no-repeat top center / cover;
    padding: 1rem 0;
    img{
      margin-left: 2.1%
    }


    p{
      color: white;
      font-size: 1.9rem;
      margin-bottom: 13px;
    }
  .text{
    color: white;
    font-weight: bold;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    .leftArrow, .rightArrow{
      width: 36%;
      height: 3rem;
    }
    .leftArrow{
      background: url('~@/assets/reservation/leftArrow.png') no-repeat left 66% / cover;
    }
    .rightArrow{
      background: url('~@/assets/reservation/rightArrow.png') no-repeat right 66% / cover;
    }
    .totals{
      margin: 0 1.6rem;
    }

    span{
      font-size: 48px;
      display: inline-block;
    
    }
      @media screen and (max-width: 768px) {
        span{
          font-size: 2rem;
        }
      }
  }
    @media screen and (max-width: 900px) {
      width: 100%;
      img {
        width: 100%;
      }
    }
  }
  .group{
    max-width: 54.8%;
    margin: 0 auto;
     @media screen and (max-width: 768px) { 
       max-width: unset;
       width: 86%;
     }
    ul , li{
      list-style: none;
      padding: 0;
      margin: 0;
    }
    ul{
    display: flex;
    justify-content: space-between;
    }
    li{
      margin-right: 30px;
      flex-shrink: inherit;
      &:last-child{
        margin-right: 0;
      }
      img{
        width: 100%;
        height: auto;
      }
         @media screen and (max-width: 768px) { 
            flex-shrink: 0;
            img{
                 width: auto;
                  height: 100%;
            }
         }
    }

  }
  .cafe {
    @media screen and (max-width: 900px) {
      width: 100%;
      text-align: center;
      img {
        width: 80%;
      }
    }
  }
}
// .img-splitline{
//   display: none;
// }

</style>
